const SettingsIcon = ({ className, size = 24, ...props }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 57 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M46.6234 20.5579C46.6234 20.5552 46.6227 20.5526 46.6214 20.5503L45.317 18.2868C44.2117 16.3686 41.7624 15.7068 39.8415 16.8075L39.8415 16.8075C38.9272 17.3461 37.8361 17.4989 36.8089 17.2322C35.7818 16.9655 34.9029 16.3012 34.3661 15.3858C34.0207 14.8039 33.8352 14.1412 33.8281 13.4646L33.8281 13.4646C33.8593 12.3798 33.4501 11.3286 32.6936 10.5505C31.9372 9.77237 30.898 9.33354 29.8128 9.33398H27.1808C26.1176 9.33397 25.0982 9.75763 24.3483 10.5112C23.5983 11.2648 23.1795 12.2862 23.1847 13.3493L23.1847 13.3493C23.1531 15.5444 21.3646 17.3072 19.1693 17.307C18.4927 17.3 17.83 17.1144 17.2481 16.7691L17.2481 16.7691C15.3272 15.6684 12.8779 16.3301 11.7727 18.2484L10.3702 20.5538C9.2663 22.4697 9.91904 24.9175 11.8303 26.0293L11.8303 26.0293C13.0727 26.7466 13.838 28.0721 13.838 29.5067C13.838 30.9412 13.0727 32.2668 11.8303 32.9841L11.8303 32.9841C9.92147 34.0884 9.26801 36.5302 10.3702 38.4403L10.3702 38.4403L11.6958 40.7265C12.2137 41.6609 13.0825 42.3505 14.1101 42.6425C15.1378 42.9346 16.2394 42.8051 17.1713 42.2827L17.1713 42.2827C18.0874 41.7482 19.179 41.6017 20.2036 41.8759C21.2282 42.1501 22.1008 42.8222 22.6275 43.7428C22.9728 44.3247 23.1584 44.9874 23.1654 45.664L23.1654 45.664C23.1654 47.8816 24.9632 49.6794 27.1808 49.6794H29.8128C32.0229 49.6794 33.8176 47.8933 33.8281 45.6832L33.8281 45.6832C33.823 44.6168 34.2444 43.5924 34.9985 42.8383C35.7527 42.0842 36.777 41.6628 37.8435 41.6679C38.5184 41.686 39.1785 41.8708 39.7647 42.2059L39.7647 42.2059C41.6805 43.3098 44.1283 42.657 45.2401 40.7457L45.2401 40.7457L46.6234 38.4403C47.1588 37.5213 47.3058 36.4267 47.0317 35.399C46.7577 34.3713 46.0852 33.4952 45.1633 32.9648L45.1633 32.9648C44.2413 32.4345 43.5689 31.5584 43.2948 30.5307C43.0208 29.503 43.1677 28.4084 43.7032 27.4894C44.0513 26.8815 44.5554 26.3775 45.1633 26.0293L45.1633 26.0293C47.0631 24.9181 47.7143 22.4846 46.6234 20.5731L46.6234 20.5731V20.5579Z" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <ellipse 
                cx="28.5062" 
                cy="29.5059" 
                rx="7.5" 
                ry="7.5" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default SettingsIcon